import AppProvider from '@Config/AppProvider'
import { Suspense } from 'react'
import '@Lang/config'
import MainMenu from '@Shared/menu/MainMenu.tsx'
import GuardProvider from '@Config/guard/GuardProvider.tsx'
import Router from '@Config/router/Router.tsx'
import { SkeletonPage } from '@shopify/polaris'
import { withSentryProfiler } from '@Utils/Sentry'

console.log(`Built at ${BUILD_DATE} running in ${CURRENT_ENV} mode...`)

function App(): JSX.Element {
  return (
    <AppProvider>
      <MainMenu />
      <Suspense fallback={<SkeletonPage />}>
        <GuardProvider>
          <Router />
        </GuardProvider>
      </Suspense>
    </AppProvider>
  )
}

const AppWithSentry = withSentryProfiler(App, { name: 'App' })

export default AppWithSentry
